import {ImbalanceItem, MonthOption} from "./types";

export function adjUnits(item: ImbalanceItem): number {
    return Math.abs(item.persistentImbalance);
}

export function skuKey(item: ImbalanceItem): string {
    return `${item.material}_${item.size}_${item.coo}_${item.quality}`;
}

export function generateMonthOptions(): MonthOption[] {
    const now = new Date();
    const opts: MonthOption[] = [];
    for (let i = 0; i < 6; i++) {
        const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        opts.push({
            label: d.toLocaleDateString('en-GB', {month: 'short', year: 'numeric'}),
            value: `${yyyy}-${mm}`,
            threshold: i + 1,
        });
    }
    return opts;
}

export function exportImbalancesCsv(imbalances: ImbalanceItem[]) {
    const rows = imbalances.filter(item => item.wmsQty === 0);
    let csv = 'Material,Size,Quality,COO,WMS_Qty,CI_Bonded,CI_NonBonded,CI_Total,Imbalance,PersistentImbalance\n';
    rows.forEach(item => {
        csv += `${item.material},${item.size},${item.quality},${item.coo},${item.wmsQty},${item.ciBondedQty},${item.ciNonBondedQty},${item.ciTotalQty},${item.imbalance},${item.persistentImbalance}\n`;
    });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob([csv], {type: 'text/csv'}));
    a.download = 'wms-zero-lines-ELC.csv';
    a.click();
}
